import { render, staticRenderFns } from "./FilterItemTapirMd.vue?vue&type=template&id=33dc7236&scoped=true&"
import script from "./FilterItemTapirMd.vue?vue&type=script&lang=js&"
export * from "./FilterItemTapirMd.vue?vue&type=script&lang=js&"
import style0 from "./FilterItemTapirMd.vue?vue&type=style&index=0&id=33dc7236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dc7236",
  null
  
)

export default component.exports